<template>
  <v-container>
    <v-row class="text-center">
      <v-col>
        <v-checkbox v-model="inInventory" label="Products In Inventory" color="red" @change="refreshList" hide-details />
      </v-col>
    </v-row>
    <v-row class="grid text-center">
      <template v-if="!loading && buyRequests.length">
        <v-col v-for="buyRequest in buyRequests" cols="12" sm="12" md="6" lg="4" :key="buyRequest.id">
          <buy-request-item :key="buyRequest.id" :item="buyRequest" />
        </v-col>
      </template>
      <v-col v-else-if="loading">
        <loader in-block />
      </v-col>
      <v-col v-else>
        <div class="no-entities-message">
          {{ $t('nobody_is_buying_now') }}
        </div>
      </v-col>
    </v-row>
    <create-buy-request ref="createBuyRequestDialog" />
  </v-container>
</template>
<script>
import BuyRequestItem from '@/components/Auction/BuyRequestItem'
import CreateBuyRequest from '@/components/Auction/Modals/CreateBuyRequest'
import Loader from '@/components/Core/Loader'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SellTab',
  components: {
    BuyRequestItem,
    CreateBuyRequest,
    Loader
  },
  data: () => ({
    inInventory: false,
    loading: true
  }),
  async mounted () {
    await this.refreshList()
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    ...mapGetters({
      buyRequests: 'auction/buy_request/getBuyRequests'
    })
  },
  methods: {
    ...mapActions({
      loadBuyRequests: 'auction/buy_request/loadBuyRequests'
    }),
    async refreshList () {
      await this.loadBuyRequests({
        products_in_inventory: this.inInventory
      })
    },
    openBuyRequestModal () {
      this.$refs.createBuyRequestDialog.openDialog()
    }
  }
}
</script>
<style scoped>
.grid {
    margin: 50px 30px;
}

.no-entities-message {
    margin: 0 auto;
    max-width: 300px;
    padding: 20px 40px;
    background: #E8FFFA;
    border: 1px solid #BDE5DD;
    border-radius: 10px;
    color: #649187;
}
</style>
